import { PersonaInfoSummary } from '@/therapist/pages/tasks/types/Task'

import { axios, Response } from '../index'
import { FolderVisibility } from '../templatesArquive/create-template'
import {
  AccessProfilePermissionResponse,
  FolderPermissionFolder
} from './create-folder'

export interface Body {
  name: string
  parentFolderId?: string | null
}

export type GroupFolder = {
  id: string
  name: string
  folderVisibility: FolderVisibility
  parentFolderId: string
  createdAt: string
  updatedAt: string
  createdBy: PersonaInfoSummary
  permissions: FolderPermissionFolder
  accessProfilePermissions: AccessProfilePermissionResponse
}

export default async function createFolderGroup(
  groupId: string,
  body: Body
): Response<GroupFolder> {
  return await axios.post(`/v1/group/${groupId}/folders`, body)
}
